<div *ngIf="loading$ | async; else loaded" class="spinner">
  <sd-spinner [size]="100"></sd-spinner>
</div>

<ng-template #loaded>
  <sd-wishlist-content-error *ngIf="error$ | async; else content"></sd-wishlist-content-error>
</ng-template>

<ng-template #content>
  <ng-container *ngIf="entries$ | async as entries; else empty">
    <sd-wishlist-content-entries *ngIf="entries.length; else empty" [entries]="entries"></sd-wishlist-content-entries>
  </ng-container>
</ng-template>

<ng-template #empty>
  <sd-wishlist-content-empty></sd-wishlist-content-empty>
</ng-template>
